import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { ApiComplianceAdapterService } from './_api/api-compliance-adapter/api-compliance-adapter.service';
import { ApiContactService } from './_api/api-contact/api-returns/api-contact.service';
import { ApiFastSintService } from './_api/api-fast-sint/api-fast-sint.service';
import { ApiFeelCommonService } from './_api/api-feel/services/common.service';
import { ApiFeelPointsProgramService } from './_api/api-feel/services/points-program.service';
import { ApiCardinalService } from './_api/api-payment/api-cardinal.service';
import { ApiIdealService } from './_api/api-payment/api-ideal.service';
import { ApiKlarnaService } from './_api/api-payment/api-klarna.service';
import { ApiPseService } from './_api/api-payment/api-pse.service';
import { ApiWalletService } from './_api/api-payment/api-wallet.service';
import { ApiSecureService } from './_api/api-secure/api-secure.service';
import { ApiShippingPromotionsService } from './_api/api-shipping-promotions/api-shipping-promotions.service';
import { ApiTopSalesService } from './_api/api-top-sales/api-top-sales.service';
import { CartErrorService } from './cart/cart-error.service';
import { ComingSoonBackSoonService } from './coming-soon-back-soon/coming-soon-back-soon.service';
import { ComplianceAdapterService } from './compliance-adapter/compliance-adapter.service';
import { EcommerceRequestInterceptor } from './errors/request-interceptor';
import { GeolocationServices } from './geolocation/services/geolocation.service';
import { AliPayService } from './order/aliPay.service';
import { CodService } from './order/cod.service';
import { OrderService } from './order/order.service';
import { IdealService } from './payment/ideal.service';
import { PseService } from './payment/pse.service';
import { WalletService } from './payment/wallet.service';
import { ShippingPromotionsService } from './promotions/shipping-promotions.service';
import { SecureService } from './secure/secure.service';
import { ShippingService } from './shipping/shipping.service';

import { ApiAddressService } from '@api/_api/api-address/api-address.service';
import { ApiCartService } from '@api/_api/api-cart/api-cart.service';
import { ApiProductsService } from '@api/_api/api-catalog/api-products/api-products.service';
import { ApiGeolocationService } from '@api/_api/api-geolocation/services/api-geolocation.service';
import { ApiPurchaseAttemptService } from '@api/_api/api-purchase-attempt/api-purchase-attempt.service';
import { ApiShippingService } from '@api/_api/api-shipping/api-shipping.service';
import { ApiDroppointListsService } from '@api/_api/api-store-locator/api-droppoint-lists/api-droppoint-lists.service';
import { ApiPhysicalStoreService } from '@api/_api/api-store-locator/api-physical-store/api-physical-store.service';
import { ApiUserService } from '@api/_api/api-user/api-user.service';
import { AddressService } from '@api/address/address.service';
import { CartService } from '@api/cart/cart.service';
import { ProductsService } from '@api/catalog/products/products.service';
import { CountryService } from '@api/country/country.service';
import { CardinalService } from '@api/payment/cardinal.service';
import { PaymentService } from '@api/payment/payment.service';
import { PurchaseAttemptService } from '@api/purchase-attempt/purchase-attempt.service';
import { DroppointListsService } from '@api/store-locator/droppoint-lists/droppoint-lists.service';
import { PhysicalStoreService } from '@api/store-locator/physical-store/physical-store.service';
import { UserService } from '@api/users/user.service';
import { UserTransformer } from '@api/users/user.transformer';

@NgModule({
    imports: [CommonModule, HttpClientModule],
    declarations: [],
    providers: [
        AddressService,
        AliPayService,
        ApiAddressService,
        ApiCardinalService,
        ApiCartService,
        ApiComplianceAdapterService,
        ApiContactService,
        ApiDroppointListsService,
        ApiFastSintService,
        ApiFeelCommonService,
        ApiFeelPointsProgramService,
        ApiGeolocationService,
        ApiIdealService,
        ApiKlarnaService,
        ApiPhysicalStoreService,
        ApiProductsService,
        ApiPseService,
        ApiPurchaseAttemptService,
        ApiSecureService,
        ApiShippingPromotionsService,
        ApiShippingService,
        ApiTopSalesService,
        ApiUserService,
        ApiWalletService,
        CardinalService,
        CartErrorService,
        CartService,
        CodService,
        ComingSoonBackSoonService,
        ComplianceAdapterService,
        CountryService,
        DroppointListsService,
        EcommerceRequestInterceptor,
        GeolocationServices,
        IdealService,
        OrderService,
        PaymentService,
        PhysicalStoreService,
        ProductsService,
        PseService,
        PurchaseAttemptService,
        SecureService,
        ShippingPromotionsService,
        ShippingService,
        UserService,
        UserTransformer,
        WalletService,
    ],
})

/**
 * Módulo de API
 */
export class IdtEcommerceApiModule {}
